var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"referential-score"},[_c('strong',[_vm._v(_vm._s(_vm.score))]),_c('MetricInfoTooltip',{attrs:{"content":_vm.REFERENTIAL_SCORE_HELP_TEXT}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }